<template>
  <div>
    <body id="sign">
      <div class="memberBox">
      <h3>{{title}}</h3>
      <!---탭 --->
      <div class="t_box"><span v-bind:class='mtab_id' style="cursor: pointer"><a @click="active=0">아이디찾기</a></span><span v-bind:class='mtab_pw' style="cursor: pointer"><a @click="active=2">비밀번호 변경</a></span></div>
      <!---//탭 --->
        <component :is="whichStep" v-bind:param="param" @child="next"></component>
    <!--- 로그인푸터 --->
    </div>
    </body>
  </div>

</template>


<script>

  export default {
    components: { // 여기서 동적으로 로딩한다
      'FindId': () => import('./account/FindId'),
      'FindIdComplete': () => import('./account/FindIdComplete'),
      'FindPasswordStep1': () => import('./account/FindPasswordStep1'),
      'FindPasswordStep2': () => import('./account/FindPasswordStep2'),
      'FindPasswordStep3': () => import('./account/FindPasswordStep3'),
      'FindPasswordComplete': () => import('./account/FindPasswordComplete')
    },
    props:['prop_active'],
    data () {
      return {
        active: 0,
        title : "회원계정 찾기",
        mtab_id : "mtab_on",
        mtab_pw : "mtab",
        param : []
      }
    },
    created(){
      this.active = this.prop_active
    },
    methods: {
      next(resultData) {
        if (this.active++ > 4) {this.active = 0}
        if(resultData != null){this.param = resultData;}
      }
    },
    computed: {
      whichStep () {
        switch (this.active) {
          case 0:
            this.mtab_id = "mtab_on"
            this.mtab_pw = "mtab"
            return 'FindId'
          case 1:
            this.mtab_id = "mtab_on"
            this.mtab_pw = "mtab"
            return 'FindIdComplete'
          case 2:
            this.mtab_id = "mtab"
            this.mtab_pw = "mtab_on"
            return 'FindPasswordStep1'
          case 3:
            this.mtab_id = "mtab"
            this.mtab_pw = "mtab_on"
            return 'FindPasswordStep2'
          case 4:
            this.mtab_id = "mtab"
            this.mtab_pw = "mtab_on"
            return 'FindPasswordStep3'
          case 5:
            this.title="비밀번호 재설정 완료"
            return 'FindPasswordComplete'
          default:
            this.mtab_id = "mtab_on"
            this.mtab_pw = "mtab"
            return 'FindId'
        }
      }
    }
  }
</script>

<style scoped>

</style>
